import React, { useState, useEffect } from 'react'
import Footer from '../common/Footer'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import SalesHeader from '../common/SalesHeader';
import AMHeader from '../common/AMHeader';
import RMHeader from '../common/RMHeader';
import axios from 'axios';
import * as Constants from "../../Constants/index"
import swal from 'sweetalert';
import { saveAs } from 'file-saver';

export default function RptAnomaly() {
    const [isVisible, setIsVisible] = useState(false);
    const [loading, setLoading] = useState(false)
    const [limit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchRecord, setSearchRecord] = useState('');
    const [results, setResults] = useState([]);

    const handleScroll = () => {
        const scrollTop = window.pageYOffset;
        setIsVisible(scrollTop > 200);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        fetchApi(searchRecord);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [currentPage]);

    const fetchApi = async (userName) => {
        let token = localStorage.getItem("token");
        const searchUserVal = userName ? `&mobile=${userName}` : "";
        try {
            setLoading(true);
            const response = await axios.get(
                `${Constants.baseUrl}reports/AnomalyUsers/list?userType=MEMBER&sortBy=createdDateTime&sortAsc=true&limit=${limit}&page=${currentPage}${searchUserVal}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Accept-Language": localStorage.getItem("langauge"),
                        appVersion: Constants.av,
                        platform: Constants.pt,
                        company: Constants.company,
                        program: Constants.program,
                    },
                }
            );

            if (response.status === 201) {
                const res = response.data;
                if (res.code === 10001) {
                    setResults(res.output.results);
                    setTotalPages(res.output.totalPages);
                } else if (res.code === 12002) {
                    setResults([]);
                    setTotalPages(0);
                } else {
                    swal({ text: res.msg, timer: 2000, buttons: false });
                }
            } else {
                swal({ text: response.data.msg, timer: 2000, buttons: false });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const download = () => {
        let token = localStorage.getItem('token');
        try {
            axios.get(Constants.baseUrl + `reports/download/anomalyUserReport`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Accept-Language": localStorage.getItem("langauge"),
                    appVersion: Constants.av,
                    platform: Constants.pt,
                    company: Constants.company,
                    program: Constants.program,
                },
                responseType: 'blob',
            })
                .then((res) => {
                    if (res.status === 200) {
                        const fileData = new Blob([res.data], { type: 'text/csv' });
                        saveAs(fileData, 'anomaly.csv');
                    } else {
                        swal({ text: res.data.msg, timer: 2000, buttons: false });
                    }
                })
        } catch (error) {
            console.log(error)
        }
    }

    const handleSearch = (e) => {
        setSearchRecord(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        fetchApi(searchRecord);
    };

    let headerComponent;
    const userType = localStorage.getItem('user_type');
    if (userType === 'SALES') headerComponent = <SalesHeader />;
    else if (userType === 'SH') headerComponent = <AMHeader />;
    else headerComponent = <RMHeader />;

    return (
        <>
            <div className="wrapper home-2">
                {headerComponent}
                <section className="blog-area pt182">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="all-single-blog rpt">
                                    <form onSubmit={handleSubmit} className="row clearfix mb-15">
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                            <div className="form-group has-float-label style-two">
                                                <label>Name / ID</label>
                                                <input type="text" className="form-control" value={searchRecord} onChange={handleSearch} />
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                            <div className="form-group has-float-label style-two">
                                                <label className="invisible" style={{ width: '100%' }}>hidden</label>
                                                <input id="btnsubmit" className="btn login_btn up-side" type="submit" value="Submit" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="all-single-blog rpt">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="carrd1">
                                                <div className="card-header card-header-warning">
                                                    <h4 className="card-title">
                                                        Anomaly Report
                                                        <Link className="fa fa-file-excel-o pull-right" onClick={download} to="#"> Export</Link>
                                                    </h4>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <div className="table table-striped mb_01">
                                                        <table className="table table-bordered mytable" style={{ width: '100%' }}>
                                                            <thead>
                                                                <tr>
                                                                    {/* <th>Sr.No.</th> */}
                                                                    <th>Member Name</th>
                                                                    <th>Member Mobile Number</th>
                                                                    <th>Region</th>
                                                                    <th>State</th>
                                                                    <th>District</th>
                                                                    <th>City</th>
                                                                    <th>Sales Person Name</th>
                                                                    <th>Sales Person Mobile</th>
                                                                    <th>Area Manager Name</th>
                                                                    <th>RSM Manager Name</th>
                                                                    <th>Anomaly Id</th>
                                                                    <th>Date Of Anomaly Scan</th>
                                                                    {/* <th>Anomaly Status</th> */}
                                                                    <th>No. Of Anomaly Scans</th>
                                                                    <th>Anomaly Scanned Value</th>
                                                                    <th>Total Points Earned</th>
                                                                    <th>Total Points Redeemed</th>
                                                                    <th>Total Balance Points</th>
                                                                    <th>First Scan</th>
                                                                    <th>LastSuccessScan Id</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {results && results.length > 0 ? (
                                                                    results.map((item, idx) => (
                                                                        <tr key={idx}>
                                                                            <td>{item[0]}</td>
                                                                            <td>{item[1]}</td>
                                                                            <td>{item[2]}</td>
                                                                            <td>{item[3]}</td>
                                                                            <td>{item[4]}</td>
                                                                            <td>{item[5]}</td>
                                                                            <td>{item[6]}</td>
                                                                            <td>{item[7]}</td>
                                                                            <td>{item[8]}</td>
                                                                            <td>{item[9]}</td>
                                                                            <td>{item[10]}</td>
                                                                            <td>{item[11]}</td>
                                                                            <td>{item[12]}</td>
                                                                            <td>{item[13]}</td>
                                                                            <td>{item[14]}</td>
                                                                            <td>{item[15]}</td>
                                                                            <td>{item[16]}</td>
                                                                            <td>{item[17]}</td>
                                                                            <td>{item[18]}</td>
                                                                            {/* <td>{item[19]}</td>
                                                                            <td>{item[20]}</td> */}
                                                                            {/* <td>{item[21]}</td>
                                                                            <td>{item[22]}</td> */}
                                                                            {/* <td>{item[23]}</td>
                                                                            <td>{item[24]}</td>
                                                                            <td>{item[25]}</td> */}
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="17" className="text-center">No Data Found</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>

                                                        {/* Pagination */}
                                                        {totalPages > 1 && (
                                                            <div className="pagination-container text-center mt-3">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>Previous</button>
                                                                        </li>
                                                                        {[...Array(totalPages)].map((_, i) => (
                                                                            <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>Next</button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
                <Link id="scrollUp" to="" className={`scroll-to-top-button ${isVisible ? 'visible' : 'hidden'}`} style={{ position: 'fixed', zIndex: '2147483647' }} onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faChevronUp} />
                </Link>
            </div>
        </>
    )
}
